"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = exports.withoutTrailingSlash = exports.tryGetValue = void 0;
function tryGetValue(val) {
    if (!val) {
        return;
    }
    if (typeof val === 'number') {
        return val.toString();
    }
    if (typeof val === 'boolean') {
        return val ? 'true' : 'false';
    }
    if (typeof val === 'string') {
        return trimOrUndefined(val);
    }
    if (!Array.isArray(val)) {
        return;
    }
    var first = val[0];
    if (typeof first === 'string') {
        return trimOrUndefined(first);
    }
}
exports.tryGetValue = tryGetValue;
function trimOrUndefined(value) {
    if (value) {
        return value;
    }
}
exports.withoutTrailingSlash = function (url) {
    return url.replace(/\/+$/, '');
};
exports.isUrl = function (url) {
    try {
        new URL(url);
        return true;
    }
    catch (_) {
        return false;
    }
};
